import {useMemo} from 'react'

const useGetLevelData = (examList, brandFilter) => {
	const examLevelOptions = examList?.find(
		(item) => String(item.franchise_idx) === String(brandFilter)
	)

	// Dynamically extract all levels from exam object
	const levelData = useMemo(() => {
		if (!examLevelOptions) return [{label: '== 모든 레벨 ==', value: 'all'}]

		const levels = [
			{label: '== 모든 레벨 ==', value: 'all'},
			{label: '없음', value: 1},
		]
		let levelIndex = 1

		// Keep checking for level_X until we don't find any more
		while (examLevelOptions[`level_${levelIndex}`] !== undefined) {
			const levelName = examLevelOptions[`level_${levelIndex}`]
			const levelIdx = examLevelOptions[`idx_level_${levelIndex}`]

			// Only add if level name exists (not null)
			if (levelName) {
				levels.push({
					label: levelName || '-',
					value: levelIdx,
				})
			}

			levelIndex++
		}

		return levels
	}, [examLevelOptions])

	return {levelData}
}

export default useGetLevelData
